import { DivWithTooltip } from "Components/withPopover";
import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    MAX_EYE_POPOVER_WIDTH: 350,
    MAX_EYE_POPOVER_HEIGHT: 300,
    EXTRA: 2
};
export default {
    ImageContainer: styled(DivWithTooltip)
        .withConfig({
        shouldForwardProp: (prop) => !includes(["error", "size"], prop)
    })
        .attrs({
        className: "d-inline-block position-relative border-rounded-circle"
    }) `
      > :first-child {
          display: none;
          width: ${({ size }) => size + SIZES.EXTRA / 2}px;
          height: ${({ size }) => size + SIZES.EXTRA / 2}px;
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(255, 255, 255, 0.7);
          border-radius: 50%;
          line-height: 1;
          z-index: ${({ theme }) => parseInt(theme["zindex-tooltip"]) + 1};
      }
      &:hover > :first-child {
          display: block;
      }

      width: ${({ size }) => size + SIZES.EXTRA * 2}px;
      height: ${({ size }) => size + SIZES.EXTRA * 2}px;
      border: ${SIZES.EXTRA}px dashed transparent;
      ${({ theme, error }) => error === "true" && `border-color: ${theme["brand-danger-400"]};`}

      &:hover {
          ${({ theme, error }) => `border-color: ${theme[error === "true" ? "brand-danger-400" : "gray-500"]};`}
      }
  `,
    EditDeleteActions: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["size"], prop)
    })
        .attrs({
        className: "position-absolute line-height-base font-small"
    }) `
      top: 0;
      left: 50%;
      background-color: transparent;
      padding: 8px 0 0 35px;
      height: ${({ size }) => size + SIZES.EXTRA / 2}px;
      display: grid;
      grid-auto-flow: column;
      gap: 8px;

      > :first-child {
          color: ${({ theme }) => theme["gray-600"]};
          &:hover {
              color: ${({ theme }) => theme["brand-primary-500"]};
          }
      }
  `,
    PreviewButton: styled(DivWithTooltip)
        .withConfig({
        shouldForwardProp: (prop) => !includes(["error", "size"], prop)
    })
        .attrs({
        className: "position-relative"
    }) `
      position: absolute;
      display: grid;
      align-content: center;
      justify-content: center;
      top: 0;
      left: 0;

      > i {
          width: ${({ size }) => size + SIZES.EXTRA * 2}px;
          height: ${({ size }) => size + SIZES.EXTRA * 2}px;
          display: grid;
          align-content: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;

          color: ${({ theme }) => theme["gray-600"]};
          &:hover {
              color: ${({ theme }) => theme["brand-primary-500"]};
          }
      }
  `
};
